import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Badge } from 'react-bootstrap';
import './Destinations.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMountain, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { BASE_URL } from '../config/config';
import BookingButton from '../bookings/BookingButton';
import { FaMapMarkerAlt } from 'react-icons/fa';

const OutdoorAdventures = () => {
  const [adventures, setAdventures] = useState([]); // State to store fetched adventures
  const [currentPage, setCurrentPage] = useState(1); // State to manage current page
  const [loading, setLoading] = useState(true); // State to show loading indicator
  const category = "outdoor_adventures";
  const [error, setError] = useState(null); // State for any errors during data fetching
  const itemsPerPage = 8; // Items per page for pagination

  // Fetch outdoor adventures from backend API
  useEffect(() => {
    const fetchAdventures = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/places/filter_by_category/?category=${category}`);
        const data = await response.json();
        
        // Assuming the backend returns an array of adventures
        setAdventures(data);
        setLoading(false); // Set loading to false when data is fetched
      } catch (error) {
        setError('Failed to fetch data. Please try again later.');
        setLoading(false);
      }
    };
    
    fetchAdventures();
  }, []); // Empty dependency array means this runs once after component mounts

  // Calculate the index of the first and last items to display on the current page
  const lastIndex = currentPage * itemsPerPage;
  const firstIndex = lastIndex - itemsPerPage;

  // Slice the adventures array to get the items to show on the current page
  const currentAdventures = adventures.slice(firstIndex, lastIndex);

  // Calculate the total number of pages
  const totalPages = Math.ceil(adventures.length / itemsPerPage);

  // Handle the page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Container fluid className="mt-2">
      <h5 className="text-center mb-3">
        <FontAwesomeIcon icon={faMountain} /> Outdoor Adventures
      </h5>
     {/* Short paragraph about outdoor adventures */}
      <p className="adventure-info-text text-center">
        Embark on thrilling journeys, explore breathtaking landscapes, and create unforgettable memories with our carefully selected outdoor adventures.
      </p>
      {loading ? (
        <div className="dot-loader">
          <span></span>
          <span></span>
          <span></span>
        </div>
      ) : error ? (
        <p className="text-danger">{error}</p>
      ) : adventures.length === 0 ? (
        <div className="text-center mt-5">
          <FontAwesomeIcon icon={faExclamationCircle} size="3x" className="text-warning mb-3" />
          <h4>No Outdoor Adventure Available</h4>
          <p>Currently, there are no outdoor adventures to display. Please check back later.</p>
        </div>
      ) : (
        <Row xs={1} sm={2} md={3} lg={4} className="g-4">
          {currentAdventures.map(adventure => (
<Col key={adventure.id}>
  <div className="destination-card w-100 shadow-sm rounded" style={{ border: '1px solid #ddd', backgroundColor: '#fff' }}>
    <img 
      src={adventure.imageUrl || 'https://assets.codepen.io/4787486/oak_1.jpg'} 
      alt={adventure.name} 
      className="img-fluid mb-3 rounded-top"
      style={{ objectFit: 'cover', height: '250px' }}
    />
    <div className="p-3">
      <h5 className="font-weight-bold" style={{ color: '#333' }}>{adventure.name}</h5>
    

      {/* Price and Location alignment */}
      <div className="d-flex justify-content-between align-items-center">
        <p className="price">KES {adventure.price}</p>
        <p className="location text-muted"> <FaMapMarkerAlt style={{ marginRight: '5px', color: '#e91e63' }} /> {adventure.location}</p>
      </div>

      <div className="d-flex justify-content-between align-items-center mt-3">
        <BookingButton place={adventure} />
      </div>
    </div>
  </div>
</Col>

          ))}
        </Row>
      )}

      {/* Pagination */}
      <div className="pagination text-center mt-4">
        <Button 
          variant="outline-primary" 
          disabled={currentPage === 1} 
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Previous
        </Button>
        <span className="mx-2">Page {currentPage} of {totalPages}</span>
        <Button 
          variant="outline-primary" 
          disabled={currentPage === totalPages} 
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </Button>
      </div>
    </Container>
  );
};

export default OutdoorAdventures;
